import moment from 'moment';
import PropTypes from 'prop-types';

const dateFormat = 'DD-MM-YYYY';
export const assignmentDefaultProps = {
  assignmentTitle: '',
  assignmentDescription: '',
  assignmentGradeable: true,
  attachmentRequired: true,
  commentRequired: false,
  assignmentMaxGrade: '',
  assignmentDueDate: moment().format(dateFormat),
  assignmentInstanceId: '',
  attachment: null,
  language: 'ENGLISH',
  onGoBack: () => {},
};

export const assignmentPropTypes = {
  onGoBack: PropTypes.func,
  assignmentTitle: PropTypes.string,
  assignmentDescription: PropTypes.string,
  assignmentGradeable: PropTypes.bool,
  attachmentRequired: PropTypes.bool,
  commentRequired: PropTypes.bool,
  assignmentMaxGrade: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  assignmentDueDate: PropTypes.string,
  mutation: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  assignmentInstanceId: PropTypes.string,
  attachment: PropTypes.object,
  mloData: PropTypes.object.isRequired,
  language: PropTypes.string,
};
